import type { PerformanceResourceItem } from '@/app/lib/api/types-api'

import { resolveInfoNotes } from './resolveInfoNotes'
import type { PerformanceViewOptions } from './types'

export type SpecialConditionsInput = Pick<PerformanceResourceItem, 'info_notes'>

/**
 * ¿El evento tiene condiciones especiales que avisar?
 *
 * Es el interruptor de dos piezas del diseño nuevo de la ficha: el banner
 * amarillo sobre el breadcrumb y la etiqueta amarilla del rail del hero.
 *
 * Se define exactamente como «hay al menos un aviso que pintar», delegando en
 * `resolveInfoNotes` — la misma normalización que alimenta el bloque de
 * promociones, que es a donde apunta el «consúltalas aquí» del banner. Así el
 * aviso y su destino no pueden discrepar. Por eso recibe las mismas opciones de
 * vista (vigencia incluida) que el bloque de promociones.
 */
export function hasSpecialConditions(
  resource: SpecialConditionsInput,
  options: PerformanceViewOptions = {},
): boolean {
  return resolveInfoNotes(resource.info_notes, { now: options.now ?? new Date() }).length > 0
}
